export enum MatchFixtureGroupType {
  League = 1,
  KnockOut = 2,
  GroupStage = 3,
}
